const shipping = () => {


    $('.invoice-shipping-help').click(e => {
        $('.factor-shipping-modal').css('display', 'block');
        $('.modal-overlay').show();
        $('#site-container').addClass('blur');
        $('body').css('overflow', 'hidden')
    })
    $('.modal-close-window').click(e => {
        $('.factor-shipping-modal').css('display', 'none');
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');
    })
    $('.modal-overlay').click(e => {
        $('.factor-shipping-modal').css('display', 'none');
        // hide overlay
        $('.modal-overlay').hide();

        // hide modal
        $('.modal').fadeOut();

        // remove blur
        $('#site-container').removeClass('blur');

        // reset body
        $('body').css('overflow', 'auto');
    })

};

export {
    shipping
};
